<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="form">

      <div class="card mb-3">
        <div class="card-header"> <h2>Event Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Event ID</mat-label>
                <input matInput formControlName="eventId">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Date of Event</mat-label>
                <input matInput formControlName="eventDate">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Event Time</mat-label>
                <input matInput formControlName="time">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>UDYAM Number</mat-label>
                <input matInput formControlName="udyamRegistrationNumber">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Implementation Agency</mat-label>
                <input matInput formControlName="nameOfOrganisation">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Intervention</mat-label>
                <input matInput formControlName="interventionName">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Component</mat-label>
                <input matInput formControlName="interestName">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"> <h2>Entrepreneur Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name of Entrepreneur</mat-label>
                <input matInput formControlName="nameOfEnterprise">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Type of Organization</mat-label>
                <input matInput formControlName="typeOfOrganization">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner's Mobile Number</mat-label>
                <input matInput formControlName="ownersMobileNumber">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner’s Gender</mat-label>
                <input matInput formControlName="gender">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Sector</mat-label>
                <input matInput formControlName="sector">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Social Category</mat-label>
                <input matInput formControlName="socialCategory">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner’s Address</mat-label>
                <input matInput formControlName="ownersaddress">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Official Address of Enterprise</mat-label>
                <input matInput formControlName="officialAddressOfEnterprise">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>State</mat-label>
                <input matInput formControlName="stateName">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>District</mat-label>
                <input matInput formControlName="districtName">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Block</mat-label>
                <input matInput formControlName="block">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>City</mat-label>
                <input matInput formControlName="city">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Pin</mat-label>
                <input matInput formControlName="pin">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="card md-3">
        <div class="card-header"> <h2>Training details</h2></div>
        <div class="card-body">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Anchor/Trainer Name</th>
                <th>Anchor/Trainer Company Name</th>
                <th>Contact Number</th>
                <th>District</th>
                <th>City</th>
                <th>Town/Block</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of dataSource; index as i">
                <td>{{ item.trainerName }}</td>
                <td>{{ item.trainerCompanyName }}</td>
                <td>{{ item.contactNumber }}</td>
                <td>{{ item.districtName }}</td>
                <td>{{ item.cityName }}</td>
                <td>{{ item.blockName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--This is for Participant Details-->
      <div class="card md-3">
        <div class="card-header"> <h2>Participant details</h2></div>
        <div class="card-body">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Participant Name</th>
                <th>Mobile Number</th>
                <th>Designation</th>
                <th>Email</th>
                <th>EnrollmentID</th>
              </tr>
            </thead>
            <tbody>
            <!--  {participantName: 'SHRI SHARAD BHARAT MANDAVE', mobileNumber: '9969448755', designation: 'SSD', emailId: 'sharadmandave3082@gmail.com', enrollmentId: 'MSME_MH-30-0000001_299'}-->
              <tr>
                <td>{{ participants.participantName }}</td>
                <td>{{ participants.mobileNumber }}</td>
                <td>{{ participants.designation }}</td>
                <td>{{ participants.emailId }}</td>
                <td>{{ participants.enrollmentId }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Iterate through each section -->
      <div *ngFor="let section of sections">
        <!-- Display section title -->
        <h2>{{ section }}</h2>
        <!-- Iterate through questions in the section -->
        <div class="section">
          <div *ngFor="let question of questionsBySection[section]">
            <mat-form-field *ngIf="question.answerType === 'Text'" appearance="outline">
              <mat-label>{{ question.questionText }}</mat-label>              
              <input matInput [formControlName]="'question_' + question.questionId" placeholder="Enter your answer" />
            </mat-form-field>

            <div *ngIf="question.answerType === 'Radio'">
              <mat-label>{{ question.questionText }}</mat-label>
              <div class="col">
                <mat-radio-group [formControlName]="'question_' + question.questionId">
                  <mat-radio-button *ngFor="let option of question.options" [value]="option.value">
                    {{ option.text }}                    
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <!--<div *ngIf="question.answerType === 'Dropdown'">
          <mat-form-field appearance="outline">
            <mat-label>{{ question.questionText }}</mat-label>
            <mat-select [formControlName]="'question_' + question.questionId">
              <mat-option *ngFor="let option of question.options" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->
            <!--<div *ngIf="question.answerType === 'Checkbox'">
          <mat-label>{{ question.questionText }}</mat-label>
          <mat-checkbox *ngFor="let option of question.options; let i = index" [formControlName]="'question_' + question.questionId + '_' + i">
            {{ option }}
          </mat-checkbox>
        </div>-->

            <div *ngIf="question.answerType === 'Checkbox'">
              <mat-label>{{ question.questionText }}</mat-label>
              <div style="display:inline" *ngFor="let option of question.options; let i = index"
                   [formGroupName]="'question_' + question.questionId">
                <mat-checkbox [formControlName]="i">{{ option }}</mat-checkbox>
              </div>
            </div>

          </div>
        </div>

      </div>
      <button mat-raised-button type="submit" (click)="onSubmit()" [disabled]="form.invalid || isDisable" *ngIf="!notMSMEUser">Submit</button>
    </form>
    <button type="submit" class="btn btn-info" (click)="onPressBack()" *ngIf="notMSMEUser">Back</button>
  </div>
</div>
